import React, { Fragment, useState } from 'react';
import flyingLogo from 'Assets/img/svg/logos/flyingLogo.svg';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import CustomCheckBox from 'Components/CheckBox/CustomCheckBox';
import { useStyles } from './signup.style';
import { useDispatch, useSelector } from 'react-redux';
import { registerParent } from '../../../ReduxStore/user';
import { RootState } from '../../../ReduxStore/store';
import Background from 'Components/Reusable/Background/Background';
import { Link, useHistory } from 'react-router-dom';
import { Routes } from 'Utils';
import { Bounce, Fade } from 'react-awesome-reveal';
import Selector from 'Components/Selector/Selector';
import CustomRadio from 'Components/Reusable/Buttons/CustomRadio';
import { radioButtonItems } from 'Utils/options';
interface State {
	fullName: string;
	email: string;
	password: string;
	childFullName: string;
	dateOfBirth: string;
	showPassword: boolean;
}

const validationSchema = yup.object({
	email: yup.string().email('Enter a valid email').required('Email is required'),
	password: yup.string().min(8, 'Password needs to be 8 or more characters').required('Password is required'),
});

const SignUp = () => {
	const classes = useStyles();
	const history = useHistory();
	const [values, setValues] = useState<State>({
		fullName: '',
		email: '',
		password: '',
		childFullName: '',
		dateOfBirth: '',
		showPassword: false,
	});
	const [checked, setChecked] = useState(false);
	const [gender, setGender] = useState('');
	const [gestation, setGestation] = useState('');
	const dispatch = useDispatch();
	const errors: any = useSelector((state: RootState) => state.users['errors']);
	const isRegistred: any = useSelector((state: RootState) => state.users['isRegistered']);
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	const loginElements = [
		{
			id: 1,
			name: 'fullName',
			type: 'text',
			fvalue: 'fullName',
			label: 'Full Name',
			placeholder: '',
		},
		{
			id: 2,
			name: 'email',
			label: 'Email',
			type: 'email',
			fvalue: 'email',
			placeholder: '',
		},
		{
			id: 3,
			name: 'password',
			label: 'Password',
			type: 'password',
			fvalue: 'password',
			placeholder: '',
		},
	];
	const kidsElements = [
		{
			id: 1,
			name: 'childFullName',
			type: 'text',
			fvalue: 'childFullName',
			label: 'First Name',
			placeholder: '',
		},
		{
			id: 2,
			name: 'dateOfBirth',
			type: 'date',
			fvalue: 'dateOfBirth',
			label: 'Date of Birth',
			placeholder: '',
		},
	];
	const formik = useFormik({
		initialValues: {
			fullName: '',
			email: '',
			password: '',
			childFullName: '',
			dateOfBirth: '',
		},
		validationSchema: validationSchema,

		onSubmit: values => {
			dispatch(
				registerParent(
					values.fullName,
					values.email,
					values.password,
					values.childFullName,
					values.dateOfBirth,
					gender,
					gestation,
				),
			);
		},
	});
	if (isRegistred) {
		history.push(Routes.EmailSent);
	}
	const list = [
		{ id: 1, name: 'Preterm' },
		{ id: 2, name: 'Term' },
	];
	return (
		<Fragment>
			<div>
				<Background middleItem={flyingLogo} row>
					<div className={`${classes.background} px-3 py-4 mx-auto my-5`}>
						<h6 className={`${classes.signup} text-left py-2`}>Sign up</h6>
						{errors && errors.message != null ? (
							<div className="d-flex justify-content-center pt-3 alert alert-danger">
								<span className={classes.error}>{errors.message}</span>
							</div>
						) : (
							''
						)}

						<form onSubmit={formik.handleSubmit}>
							{/* <Fade> */}
							<ul className={`${classes.listItems} mb-4`}>
								<h6 className={`${classes.text} text-center py-2`}>Your Details</h6>
								{loginElements.map(element => (
									<li key={element.id} className="mt-2">
										<ReusableInput
											name={element.name}
											type={element.type}
											placeholder={element.placeholder}
											formik={formik}
											fvalue={element.fvalue}
											label={element.label}
											width="381.87px"
											height="53.91px"
										/>
									</li>
								))}
							</ul>
							{/* </Fade> */}
							{/* <Fade> */}
							<ul className={`${classes.listItems} text-center`}>
								<h6 className={`${classes.text} text-center py-2`}>{"Your child's details"}</h6>
								{kidsElements.map(element => (
									<li key={element.id} className="mt-2">
										<ReusableInput
											name={element.name}
											type={element.type}
											fvalue={element.fvalue}
											placeholder={element.placeholder}
											label={element.label}
											formik={formik}
											width="381.87px"
											height="53.91px"
											required={true}
										/>
									</li>
								))}
								<div className="d-flex flex-column flex-wrap mx-auto mt-4 mb-3 justify-content-center align-items-center">
									<section className="mb-3">
										<Selector itemList={list} gestation={setGestation} />
									</section>
									<CustomRadio items={radioButtonItems} genderChoice={setGender} componentWidth />
								</div>
							</ul>
							{/* </Fade> */}
							<div className="d-flex align-items-center justify-content-center flex-column">
								{/* <Fade> */}
								<p className={`${classes.subText} text-center p-0 m-0 mt-4`}>
									You can add second child’s details later
								</p>
								<CustomCheckBox
									checked={checked}
									mainText="I read and agree to the"
									subText=" Terms & Conditions"
									handleChangeCheckbox={handleChangeCheckbox}
								/>
								{/* </Fade> */}
								<Bounce>
									<CommonButton
										disabled={checked ? false : true}
										common={{
											width: '381.87px',
											height: '48px',
											background: '#7FD6DD',
											radius: '200px',
											fontWeight: 'lighter',
											fontSize: '24px',
											// isAuthButton:true
										}}
										isAuthButton
										command="REGISTER"
									/>
								</Bounce>
								{/* <Fade> */}
								<span className="float-end" style={{ fontSize: '14px', fontFamily: 'Poppins' }}>
									<span className="px-2">Already have an account?</span>
									<Link to={Routes.Login} className={classes.link}>
										<span style={{ color: '#FF7552', fontSize: '14px' }}>Login</span>
									</Link>
								</span>
								{/* </Fade> */}
							</div>
						</form>
					</div>
				</Background>
			</div>
		</Fragment>
	);
};

export default SignUp;
